import { combineReducers } from 'redux'
import Auth from './Auth'
import Applications from './Applications'

export default combineReducers({
  auth: Auth,
  applications: Applications,
})
